import axios from "axios";

export function getBaskets(page = 1, limit) {
    return axios.get(`order/baskets?page=${page}&limit=${limit}`);
}